import React from 'react';
import IconName from "../../svgLogo/SvgLogo";
import {Link} from "react-router-dom";

const VendorStepLogin = ({step}) => {
    return (
        <div className="vendor-step-login-wrapper d-flex flex-column align-items-center">
            <div className="sayman-logo d-none d-lg-block">
                <Link to="/"><IconName name="sayman-logo" className="icon"/></Link>
            </div>
            <div className="login-steps">
                <h2 className="title-steps">ورود به مرکز فروشندگان</h2>
                <ul className={`steps-list list-unstyled ${step}`}>
                    <li className="d-flex active step">
                        <div className="step-icon"><IconName name="add_business" className="icon"/></div>
                        <div className="step-text">
                            <h3 className="title">۱. اطلاعات فروشنده</h3>
                            <p className="text">
                                اطلاعات شخصی فروشنده، اطلاعات تجاری، اطلاعات تماس
                            </p>
                        </div>
                    </li>
                    <li className="d-flex step">
                        <div className="step-icon"><IconName name="work_outline" className="icon"/></div>
                        <div className="step-text">
                            <h3 className="title">۲. بارگذاری مدارک</h3>
                            <p className="text">
                                اطلاعات مربوط به مالیات بر ارزش افزوده، تصویر مدارک شخصی و تجاری
                            </p>
                        </div>
                    </li>
                    <li className="d-flex step">
                        <div className="step-icon"><IconName name="verified_user" className="icon"/></div>
                        <div className="step-text">
                            <h3 className="title">۳. اتمام ثبت نام</h3>
                            <p className="text">
                                به جمع فروشندگان سایمان دیجیتال خوش آمدید.
                            </p>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    );
};

export default VendorStepLogin;
